import { useEffect } from "react";

import "../public/css/tailwind.css";
import { SessionProvider } from "next-auth/react";
import "../styles/index.css";

import { identityLoggedUser } from "@src/auth";

import { chatLogin as zeChatLogin } from "@src/ze";

import CustomScript from "@components/custom-script";

export default function MyApp({ Component, pageProps, err }) {
  useEffect(() => {
    identityLoggedUser();

    zeChatLogin();
  }, []);
  return (
    <SessionProvider session={pageProps.session}>
      <CustomScript />
      <Component {...pageProps} err={err} />
    </SessionProvider>
  );
}
